import ObservationCardGridView from "@/components/observations/ObservationCardGridView";
import { useSiteName } from "@/hooks/useSiteName";
import type { LayoutContext } from "@/lib/models";
import { Observation, ObservationService } from "@/services/ObservationService";
import { useEffect, useState } from "react";
import { useOutletContext, useParams } from "react-router";

const SiteObservationListPage: React.FC = () => {
  const [observations, setActionsList] = useState<Observation[]>([]);
  const params = useParams();
  const { siteName } = useSiteName(params.siteId!);
  const { setPageName } = useOutletContext<LayoutContext>();

    useEffect(() => {
      setPageName(`Site: ${siteName} Observations`);
    }, [siteName, setPageName]);

  useEffect(() => {
    ObservationService
      .getBySiteId(params.siteId!)
      .then(setActionsList);
  }, [params.siteId]);

  return (
    <div className="container mx-auto p-4">
      <ObservationCardGridView observations={observations} pageTitle={`Site: ${siteName} Observations`} />
    </div>
  );
};

export default SiteObservationListPage;
